<template>
  <div id="ScoreEntry">
    <ots-main-title :mainTopBtn="mainTopBtnList"></ots-main-title>
    <ots-refer :selectList="selectList" :requestForm="requestForm" @search="search"></ots-refer>
    <div class="mainCon">

      <el-button type="primary" style="margin-bottom: 8px;" @click="ImportThirdParty" round plain>
        <i class="el-icon-upload2"></i>
        <span>导入第三方成绩</span>
      </el-button>

      <el-button type="primary" style="margin-bottom: 8px;" @click="Multiplexing" round plain>
        <i class="el-icon-copy-document"></i>
        <span>复用上个考试批次第三方成绩</span>
      </el-button>

      <el-button type="primary" style="margin-bottom: 8px;" @click="DeleteThirdParty" round plain>
        <i class="el-icon-delete"></i>
        <span>删除第三方成绩</span>
      </el-button>

      <el-button type="primary" style="margin-bottom: 8px;" @click="batchSaveScore" round plain>
        <i class="el-icon-delete"></i>
        <span>批量保存</span>
      </el-button>

      <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%" :header-cell-style="{textAlign: 'center'}" :cell-style="{'text-align': 'center'}" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55" :selectable="isSelectable">
        </el-table-column>
        <el-table-column prop="planName" label="考试批次" >
        </el-table-column>
        <el-table-column prop="realName" label="姓名" >
        </el-table-column>
        <el-table-column prop="entranceCode" label="准考证号" >
        </el-table-column>
        <el-table-column prop="cardNo" label="证件号" >
        </el-table-column>
        <el-table-column prop="stationName" label="教学点" >
        </el-table-column>
        <el-table-column prop="placeName" label="考点" >
        </el-table-column>
        <el-table-column prop="courseName" label="课程名称" >
        </el-table-column>
        <el-table-column prop="courseScore" label="考试成绩" >
        </el-table-column>
        <el-table-column prop="checkStateName" label="成绩状态" >
        </el-table-column>
        <el-table-column v-for="item in scoreList.length" :key="item" :label="scoreList[item - 1].typeName" min-width="128px">
          <template slot-scope="scope">
            <el-input class="typeProportion"
                      v-model="scope.row.scoreList[item - 1].score"
                      :disabled="planInfo.scorePublish || scope.row.scoreList[item - 1].typeProportion == 0 || getCheckStatusExist(scope.row.checkStateName)"
                      @input="validateNumberInput($event, scope.row.scoreList[item - 1])"
            >
            </el-input>
          </template>
        </el-table-column>
        <el-table-column prop="endScore" label="合成后分数" >
        </el-table-column>
        <el-table-column label="操作" >
          <template slot-scope="scope">
            <el-button @click="SaveType(scope.row)" type="text" :disabled="planInfo.scorePublish == 1 || getCheckStatusExist(scope.row.checkStateName)">保存</el-button>
          </template>
        </el-table-column>
      </el-table>
      <ots-pagination :pagination="pagination" @changeNum="changeNum" @changePage="changePage"></ots-pagination>
    </div>

    <ots-custom-dialog :dialog.sync="importDialog" title="导入第三方成绩">
      <template v-slot:content>
        <div class="exportDialog">
          <el-form ref="exportForm" :model="importForm">
            <el-form-item label="选择批次" class="mb20">
              <el-select v-model="importForm.planId" clearable placeholder="请选择" filterable>
                <el-option v-for="item in publishPlanList" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="1.模板下载">
              <span style="color: #006aff" @click="excelTempCreateExt()" class="cp">
                <i class="el-icon-download"></i>
                下载第三方成绩模板
              </span>
            </el-form-item>
            <el-form-item v-model="importForm.Filedata" label="3.导入文件">
              <ots-upload-file :httpRequest="handleFormData" fileType="xlsx" />
            </el-form-item>
          </el-form>

        </div>
      </template>
      <template v-slot:footer>
        <el-button round @click="importDialog = false">取消</el-button>
        <el-button round type="primary" @click="rightImport">导入</el-button>
      </template>
    </ots-custom-dialog>

    <!-- exportDialog -->
    <ots-custom-dialog :dialog.sync="exportDialog" title="导出选择">
      <template v-slot:content>
        <div class="exportDialog">
          <el-radio v-model="exportFlag" :label="false" >条件导出</el-radio>
          <el-radio v-model="exportFlag" :label="true" >全部导出</el-radio>
        </div>
      </template>
      <template v-slot:footer>
        <el-button round @click="exportDialog = false">取消</el-button>
        <el-button round type="primary" @click="exportSet">导出</el-button>
      </template>
    </ots-custom-dialog>

    <ots-custom-dialog :dialog.sync="MultiplexingDialog" title="复用批次">
      <template v-slot:content>
        <div class="exportDialog">
          <span>从批次：</span>
          <el-select v-model="fromPlanId" placeholder="请选择" style="margin-bottom: 16px;" filterable>
           <el-option v-for="item in examBatchList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
          <br />
          <span>复制到：</span>
          <el-select v-model="toPlanId" placeholder="请选择" filterable>
           <el-option v-for="item in examBatchList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </div>
      </template>
      <template v-slot:footer>
        <el-button round @click="MultiplexingDialog = false">取消</el-button>
        <el-button round type="primary" @click="MultiplexingSet">确定</el-button>
      </template>
    </ots-custom-dialog>

  </div>
</template>

<script>
import { getSelectPlanFn, getSinglePlan } from "@/http/modules/examSet/examBatch";
import { getPlanCourseList } from "@/http/modules/custom";
import { getUserTypeScoreListAPI, copySourcePlanTypeScoreAPI, exportUserTypeScoreAPI, importUserTypeScoreAPI, saveUserTypeScoreAPI, deleteUserTypeScoreAPI,saveUserTypeScoreByBatchAPI,getPlanCheckStateScopeFn } from "@/http/modules/examSet/score";
import { getPlaceList } from "@/http/modules/baseSet/examSite";
export default {
  data() {
    return {
      mainTopBtnList: [
        {
          title: "导出",
          fn: this.exportInfo,
        },
      ],
      selectList: [
        {
          title: "考试批次",
          type: "select",
          requestKey: "planId",
          label: "name",
          isSearch: true,
          value: "id",
          data: [],
        },
        {
          title: "课程名称",
          type: "select",
          requestKey: "courseIds",
          label: "courseName",
          multiple: true,
          value: "courseId",
          data: []
        },
        {
          title: "第三方成绩状态",
          type: "select",
          requestKey: "insertFlag",
          label: "name",
          value: "id",
          data: [
            {id: "", name: "全部"},
            {id: "0", name: "未录"},
            {id: "1", name: "已录"}
          ]
        },
        {
          title: "教学点",
          type: "select",
          isSearch: true,
          requestKey: "stationId",
          label: "stationName",
          value: "stationId",
          data: [],
        },
        {
          title: "考点",
          type: "select",
          requestKey: "placeId",
          label: "placeName",
          value: "placeId",
          data: [],
        },
        {
          title: "关键词",
          type: "input",
          requestKey: "keyWord",
          placeholder: "姓名/准考证/证件号",
        },
        {
          title: "分数段",
          type: "inputInterval",
          placeholder: "例如0-59",
          requestKey: "scoreMin",
          requestKeySecond: "scoreMax",
        },
        {
          title: "考试状态",
          type: "select",
          requestKey: "checkState",
          label: "name",
          value: "id",
          data: [
            { id: "", name: "全部" },
            { id: "1", name: "正常" },
            { id: "2", name: "缺考" },
            { id: "3", name: "作弊" },
            { id: "4", name: "违纪" },
            { id: "5", name: "替考" },
          ]
        },
      ],
      requestForm: {
        planId: "",
        courseIds: "",
        stationId: "",
        placeId: "",
        insertFlag: "0",
        keyWord: "",
        scoreMin: "",
        scoreMax: "",
        checkState: "",
        size: 10,
        page: 1,
      },
      multipleSelection: [],
      pagination: {
        total: 0,
      },
      tableData: [],
      importDialog: false,
      examBatchList: [],
      importForm: {
        planId: "",
        file: "",
      },
      scoreList: [],
      exportDialog: false,
      exportFlag: true,
      MultiplexingDialog: false,
      fromPlanId: "",
      toPlanId: "",
      publishPlanList: "",
      planInfo: {},
      checkStateNameList: [], //当前选择的考试批次对应的允许的《参与核算的考试状态》
    }
  },
  watch: {
    "requestForm.planId": function(planId) {
      this.getCourseList(planId);
      this.getStationList(planId);
      this.getPlaceListFN();
      this.search();
      this.getPlanInfo(planId);
      this.getCheckStateNameList(planId);
    },
    "requestForm.stationId": function() {
      this.getPlaceListFN();
    }
  },
  mounted() {
    this.initData();
  },
  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 批次详情
    async getPlanInfo(planId) {
      const { code, data } = await getSinglePlan({planId});
      if (code) {
        this.planInfo = data;
      }
    },
    search() {
      this.requestForm.page = 1;
      this.getCheckStateNameList(this.requestForm.planId);
      this.getTableList();
    },
    async initData(){
      const { code: planCode, data: planList} = await getSelectPlanFn();
      if (planCode) {
        this.selectList[0].data = [...planList];
        this.requestForm.planId = planList[0].id;
        this.examBatchList = [...planList];
      }
      const { code, data: publish } = await getSelectPlanFn({ needAudit: 15 });
      if (code) {
        this.publishPlanList = publish;
      }
    },

    async getStationList(planId) {
      this.requestForm.stationId = "";
      const {data: stationList} = await this.$api.system.getStationsForPlan({planId});
      this.selectList[3].data = [...stationList];
    },

    getCourseList(planId) {
      this.requestForm.courseIds = [];
      getPlanCourseList({planId}).then(({data})=>{
        this.selectList[1].data = [...data];
      })
    },

    handleFormData(val) {
      this.importForm.file = val.file;
    },

    async getPlaceListFN(planId) {
      let params = {
        planId: this.requestForm.planId,
        stationId: this.requestForm.stationId
      }
      const { data: placeData } = await getPlaceList(params);
      if (!placeData) {
        this.selectList[4].data = [];
        this.requestForm.placeId = '';
        return;
      }
      this.selectList[4].data = [...placeData];
      this.requestForm.placeId = "";
    },

    async getTableList() {
      let params = {...this.requestForm}
      params.courseIds = params.courseIds.join(",");
      const { code, data } = await getUserTypeScoreListAPI(params);
      if (code) {
        this.tableData = data.records;
        this.scoreList = data.records.length > 0 && data.records[0].scoreList ? data.records[0].scoreList: [];
        this.pagination.total = data.total;
      }
    },

    async SaveType(row) {
      if(row.scoreList && row.scoreList.length > 0) {
        if(row.scoreList.some(e => e.score == null || e.score == "")) {
          this.$message.error("第三方成绩还未录入，请填写完整后再保存！");
          return;
        }
      }
      let scoreList = JSON.parse(JSON.stringify(row.scoreList));
      let scores = {}
      scoreList.map(e=>{
        scores[e.planCourseTypeId] = e.score;
      })
      scores = JSON.stringify(scores);
      scores = scores.replace(/"/g, '');
      let params = {
        planId: row.planId,
        studentCourseId: row.studentCourseId,
        scores: scores.substring(1, scores.length - 1),
      }

      const { code } = await saveUserTypeScoreAPI(params);
      if (code) {
        this.$message.success("保存成功！");
      }
      this.getTableList();
    },

    exportInfo() {
      this.exportSet();
    },

    // 执行导出
    async exportSet() {
      let params = {
        exportFlag: 1,
        ...this.requestForm
      };
      params.courseIds = params.courseIds.join(",");
      // if (this.exportFlag) {
      //   params = {
      //     exportFlag: 1,
      //     planId: this.requestForm.planId
      //   }
      // 
      // } else {
      //   params = {
      //     exportFlag: 1,
      //     ...this.requestForm
      //   }
      // }
      const { data, code } = await exportUserTypeScoreAPI(params);
      if (code) {
        window.open(data) ;
      }
    },

    // 导入第三方成绩
    ImportThirdParty() {
      this.importDialog = true;
    },

    // 执行导入
    rightImport() {
      if (!this.importForm.planId) {
        this.$message.error("请选择导入批次");
        return;
      }
      if (!this.importForm.file) {
        this.$message.error("请选择文件");
        return;
      }
      const fd = new FormData();
      for (let item in this.importForm) {
        fd.append(item, this.importForm[item]);
      }
      importUserTypeScoreAPI(fd).then((res) => {
        if (res.code) {
          const failNum = res.data.errorCount ? parseInt(res.data.errorCount) : 0;
          const totalNum = parseInt(res.data.allCount);
          const successNum = totalNum - failNum;
          let message = `导入完成，成功导入${successNum}，失败人员数${failNum}`;
          this.$confirm(message, "导入结果", {
            confirmButtonText: failNum > 0 ? "查看错误记录" : "确定",
            cancelButtonText: "取消",
            type: failNum > 0 ? "warning" : "success",
          }).then(() => {
            if (failNum > 0) {
              window.location.href = res.data.address;
            }
          });
          this.getTableList();
        }
      });
      this.importDialog = false;
    },



    // 复用
    Multiplexing() {
      this.fromPlanId = "";
      this.toPlanId = "",
      this.MultiplexingDialog = true;
    },

    MultiplexingSet() {
      if (!this.fromPlanId) {
        this.$message.error("请选择您想要复用的 -- 批次来源！");
        return;
      }

      if (!this.toPlanId) {
        this.$message.error("请选择使用复用的批次！");
        return;
      }

      this.$confirm(`确认复用上个考试批次的第三方成绩？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let params = {
          toPlanId: this.toPlanId,
          fromPlanId: this.fromPlanId,
        }
        copySourcePlanTypeScoreAPI(params).then(({code}) => {
          if (code) {
            this.$message.success("已成功复用选择批次的第三方成绩项成绩！");
            this.MultiplexingDialog = false;
            this.search();
          }
        })
      }).catch(() => {});
    },

    // 删除
    DeleteThirdParty() {
      if (this.multipleSelection.length == 0) {
        this.$message.error("请勾选要删除的第三方成绩！");
        return;
      }
      this.$confirm(`该操作将删除所选择学生对应的第三方成绩。`, "提示", {
        confirmButtonText: "确定删除",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let studentCourseIds = [];
        this.multipleSelection.map(e => {
          studentCourseIds.push(e.studentCourseId)
        })
        let params = {
          studentCourseIds: studentCourseIds.join(",")
        }
        deleteUserTypeScoreAPI(params).then(({code}) => {
          if (code) {
            this.$message.success("删除成功！");
            this.getTableList();
          }
        })
      }).catch(() => {});
    },

    changeNum(num) {
      this.requestForm.size = num;
      this.getTableList();
    },
    changePage(p) {
      this.requestForm.page = p;
      this.getTableList();
    },

    // 下载模板
    async excelTempCreateExt() {
      if (!this.importForm.planId) {
        this.$message.error("请选择批次！");
        return;
      }
      let params = {
        planId:this.importForm.planId,
        exportFlag: 2
      }
      const { data, code } = await exportUserTypeScoreAPI(params);
      if (code) {
        window.open(data) ;
      }
    },
    batchSaveScore(){
      if (this.multipleSelection.length == 0) {
        this.$message.error("请勾选要批量保存的数据！");
        return;
      }
      const hasEmptyScore = this.multipleSelection.some(row => row.scoreList && row.scoreList.some(scoreListItem => scoreListItem.score == ""))
      if(hasEmptyScore){
        this.$message.error("还有勾选的记录没有填写第三方成绩，请填写完整后再进行此操作！");
        return;
      }
      let tmpParams = '';
      this.multipleSelection.forEach(row => {
        if(row.scoreList && row.scoreList.length > 0){
          tmpParams += row.studentCourseId + "#";
          row.scoreList.forEach(scoreListItem => {
            tmpParams += scoreListItem.planCourseTypeId + ':' +scoreListItem.score + ",";
          })
          tmpParams = tmpParams.substring(0,tmpParams.length-1);
          tmpParams += "$";
        }
      })
      tmpParams = tmpParams.substring(0,tmpParams.length-1);
      let params = {
        planId : this.multipleSelection[0].planId,
        scores : tmpParams
      }
      saveUserTypeScoreByBatchAPI(params).then(({code}) => {
        if (code) {
          this.$message.success("批量保存成功！");
          this.getTableList();
        }
      })
    },
    validateNumberInput(value, scoreItem) {
      let filtered = value.replace(/[^\d.]/g, '');
      if (filtered.startsWith('.')) {
        filtered = filtered.substring(1);
      }
      const dotCount = (filtered.match(/\./g) || []).length;
      if (dotCount > 1) {
        filtered = filtered.replace(/\./g, '', dotCount - 1);
      }
      const parts = filtered.split('.');
      parts[0] = parts[0].slice(0, 3);
      if (parts.length > 1) {
        parts[1] = parts[1].slice(0, 2);
      }
      this.$set(scoreItem, 'score', parts.join('.'));
    },
    async getCheckStateNameList(val){
      const { data, code } = await getPlanCheckStateScopeFn({planId: val});
      if (code) {
        this.checkStateNameList = data.filter(item=>item.checked).map(item => item.name);
      }
    },
    getCheckStatusExist(val){
      return !this.checkStateNameList.includes(val);
    },
    // 控制复选框是否可选（与保存按钮的启用逻辑保持一致）
    isSelectable(row) {
      return !(this.planInfo.scorePublish == 1 || this.getCheckStatusExist(row.checkStateName));
    },
  }

}
</script>
<style scoped lang="less">
.el-input {
  width: 96px;
}
/deep/ .el-input__inner {
  width: 96px;
}

.mb20.exportDialog /deep/ .el-input {
  width:240px;
}
.mb20,.exportDialog /deep/ .el-input__inner {
  width: 240px;
}
</style>